import { useMutation, useQueryClient } from 'react-query';

import {
  USER_ONBOARDING_KEY,
  UpdateUserOnboardingParams,
  updateUserOnboarding,
} from '@utils/backend-api/userOnboarding';

export default function useUserOnboardingUpdate() {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: UpdateUserOnboardingParams) => updateUserOnboarding(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(USER_ONBOARDING_KEY);
      },
    }
  );

  return {
    updateUserOnboarding: mutate,
    updateUserOnboardingAsync: mutateAsync,
    isUpdatingUserOnboarding: isLoading,
    isErrorUserOnboarding: isError,
  };
}
